module.exports = __webpack_public_path__ + "img/sGoldenWar_193x205.87181289.png";